import type { OnboardingStateResponseRead } from '@highlight-cp/highlighter-api';
import { highlighterApi } from '@highlight-cp/highlighter-api';

export const onboardingStateApi = highlighterApi.injectEndpoints({
  // Hot reload runs this again; without it RTK keeps the first definition.
  overrideExisting: true,
  endpoints: (build) => ({
    // Served by GET /api/account/onboarding-state, which calls the Highlighter API server-side.
    getOnboardingState: build.query<OnboardingStateResponseRead, void>({
      query: () => ({ url: 'account/onboarding-state' }),
      // Account changes (accepting TOS, activation, survey progress) already invalidate this.
      providesTags: ['HighlighterAccounts'],
    }),
  }),
});
